import { ApplicationConfig, ErrorHandler, importProvidersFrom, inject, provideAppInitializer, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, RouterModule, withEnabledBlockingInitialNavigation } from '@angular/router';

import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { GlobalErrorHandler } from '@core/classes/global-error-handler';
import { CustomHttpInterceptor } from '@core/interceptors/custom-http-interceptor';
import { ConfigService } from '@core/services/config.service';
import { FontAwesomeService } from '@core/services/font-awesome/font-awesome.service';
import { HostRouteConfigService } from '@core/services/host-route-map/host-route-config.service';
import { IndexedDbAssetTranslateLoader } from '@core/services/translation/indexeddb-asset-translate-loader';
import { TranslationUpdateService } from '@core/services/translation/translation-update.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { provideTranslateService, TranslateLoader, TranslateService } from '@ngx-translate/core';

import Aura from '@primeng/themes/aura';
import { provideNgxWebstorage, SessionStorageService, withLocalStorage, withNgxWebstorageConfig, withSessionStorage } from 'ngx-webstorage';
import { providePrimeNG } from 'primeng/config';
import { APP_ROUTES } from './app.routes';



function translateLoaderFactory(http: any) {
  return new IndexedDbAssetTranslateLoader(http, '/assets/i18n'); // ajuste se necessário
}


export const appConfig: ApplicationConfig = {
  providers: [

    { provide: ErrorHandler, useClass: GlobalErrorHandler },

    provideZoneChangeDetection(),

    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(),

    provideRouter(APP_ROUTES, withEnabledBlockingInitialNavigation()),

    provideNgxWebstorage(
      withNgxWebstorageConfig({ prefix: 'iTek', separator: '.', caseSensitive: true }),
      withLocalStorage(),
      withSessionStorage()
    ),

    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options:{
          darkModeSelector: '.app-dark',
        }
      }
    }),




    // DI interceptors, ordem importa
    { provide: HTTP_INTERCEPTORS, useClass: CustomHttpInterceptor, multi: true },
    // { provide: HTTP_INTERCEPTORS, useClass: IAuthHttpInterceptor, multi: true },

    // Habilita o uso de ambos interceptors: os funcionais que você listar e os de DI
    provideHttpClient(
      withInterceptors([
        // ex.: um interceptor funcional rápido de tracing
        (req, next) => next(req),
      ]),
      withInterceptorsFromDi()
    ),



    //old
    provideTranslateService({
      fallbackLang: 'pt',
      lang: 'pt',
      loader: {
        provide: TranslateLoader,
        useFactory: translateLoaderFactory,
        deps: [HttpClient],
      }
    }),





    // Registro do ConfigService
    // O ConfigService será automaticamente injetado no factory
    // deixar por ultimo
    ConfigService,


    importProvidersFrom([
      FontAwesomeModule,
      FormsModule,
      ReactiveFormsModule,
      RouterModule,
    ]),


    provideAppInitializer(() => {
      // faz a injeção do service que permite recuperar as configurações do servidor
      const configService = inject(ConfigService);

      // cria as injeções necessárias para o serviço de configuração
      const http: HttpClient = inject(HttpClient);
      const translateService: TranslateService = inject(TranslateService);
      const sessionStorage: SessionStorageService = inject(SessionStorageService);
      const translationUpdateService: TranslationUpdateService = inject(TranslationUpdateService);
      const hostRouteConfigService: HostRouteConfigService = inject(HostRouteConfigService);
      const fontAwesomeService: FontAwesomeService = inject(FontAwesomeService);


      // faz a requisição HTTP e mantém as configurações em memória
      return configService.loadConfig({
        hostRouteConfigService,
        http,
        translateService,
        sessionStorage,
        translationUpdateService,
        fontAwesomeService
      });


    }),




  ],

};





